import { gql } from '@apollo/client';

export const fetchCreditNoteWithInvoices = gql`
  query fetchCreditNoteWithInvoices(
    $id: ID!
    $searchOptions: ConnectionSearchOptions
    $filterOptions: InvoicesFilterOptions
  ) {
    transactionAccount(id: $id) {
      id
      refundedInvoices(searchOptions: $searchOptions, filterOptions: $filterOptions) {
        totalCount
        nodes {
          id
          invoiceDueDays
          invoiceNumber
          sourceSystem
          paymentMethod
          paymentMethodId
          creditCardMaskedNumber
          dueDate
          prePaymentCreditNotesAmount
          createdDate: createdTimestamp
          grandTotal: total
          paymentCurrency
          pricingCurrency
          transactionAccountId
          refunds {
            id
            type
            createdDate
            creditNoteNumber
            sourceSystem
            total
            currency
            status
            arn
            creditNoteId
          }
          status
          dunningStatus {
            errorCode
            nextPaymentAttempDate
          }
          shipTo {
            id
            fullName
            address {
              address1
              address2
              city
              state
              country
              postalCode
            }
          }
          purchaseOrderNumber
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`;
